<template>
  <div class="container d-flex fd-column m-b-6">
    <div>
      <div class="h3 text-bold text-center p-x-1:mo p-b-2">{{content.title}}</div>
      <div class= "text-center p-b-3">{{content.subTitle}}</div>
    </div>
    <div class="d-flex w-100 fd-column flex-0-1 FAQ-SECTION" >
      <div
          v-for="(faq, index) in content.faqs"
          :key="index"
      ><pro-faq-item
          :faq= faq />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FAQItem from './components/FAQItem';

export default {
  name: 'pro-faq-section',
  components: {
    'pro-faq-item': FAQItem,
  },

  computed: {
    ...mapGetters('homepage/contentful', [
      'proHomePage',
    ]),
    content () {
      return this.proHomePage.faqSection;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
  .FAQ-SECTION {
    display: flex;
    flex: 1 1 auto;
    @include margin-y(6);
  }
</style>
